import { Checkbox, Empty, Select } from '@maxtropy/components';
import React, { useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';
import { EnergyLabelContext } from '../..';
import { useRequest } from 'ahooks';
import {
  apiV2LabelAnalysisGroupListWithLabelPost,
  V2LabelAnalysisGroupListWithLabelPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { Divider, Spin } from 'antd';

type AnalysisGroupListItem = Exclude<V2LabelAnalysisGroupListWithLabelPostResponse['list'], undefined>[number];

export type LabelListItem = Exclude<AnalysisGroupListItem['labels'], undefined>[number];

const EnergyTree = () => {
  const { groupId, setGroupId, setLabelIds } = React.useContext(EnergyLabelContext);
  const [checkedList, setCheckedList] = useState<number[]>([]);

  // 获取用能分析组及其标签
  const { data: analysisGroups, loading } = useRequest(() =>
    apiV2LabelAnalysisGroupListWithLabelPost({}).then(res => res.list ?? [])
  );

  const groupOptions = useMemo(
    () => (analysisGroups ?? []).map(item => ({ label: item.name as string, value: item.id as number })),
    [analysisGroups]
  );

  // 默认选择第一个用能分析组
  useEffect(() => {
    if ((groupOptions ?? []).length > 0) {
      setGroupId?.(groupOptions?.[0].value!);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupOptions]);

  useEffect(() => {
    setLabelIds?.(checkedList);
  }, [checkedList]);

  const unitLabelData = useMemo<LabelListItem[]>(
    () => (analysisGroups ?? []).find(item => item.id === groupId)?.labels ?? [],
    [analysisGroups, groupId]
  );

  // 用能分析总览选择一级用能分析单元
  useEffect(() => {
    const selectedLabelIds = unitLabelData.map(item => item.labelId!);
    setCheckedList(selectedLabelIds);
  }, [unitLabelData]);

  const onCheck = (list: number[]) => {
    setCheckedList(list);
  };

  const checkAll = useMemo(() => checkedList.length === unitLabelData.length, [checkedList, unitLabelData]);
  const indeterminate = useMemo(
    () => checkedList.length > 0 && checkedList.length < unitLabelData.length,
    [checkedList, unitLabelData]
  );

  return (
    <div className={styles.leftSider}>
      <div className={styles.filterArea}>
        <div className={styles.option}>用能分析组：</div>
        <Select
          placeholder="请选择"
          className={styles.selectBox}
          value={groupId}
          allowClear={false}
          options={groupOptions}
          onChange={val => {
            setCheckedList([]);
            setGroupId?.(val);
          }}
        />
      </div>
      <div className={styles.splitLine}>
        <Divider className={styles.divider} />
      </div>
      <div className={styles.treeArea}>
        <Spin spinning={loading}>
          {unitLabelData && unitLabelData.length > 0 ? (
            <>
              <Checkbox
                indeterminate={indeterminate}
                checked={checkAll}
                className={styles.allselectbox}
                onChange={e => {
                  setCheckedList(e.target.checked ? unitLabelData.map(i => i.labelId!) : []);
                }}
              >
                全选
              </Checkbox>
              <div className={styles.tree_box}>
                <Checkbox.Group
                  value={checkedList}
                  options={unitLabelData.map(i => ({ label: i.labelName, value: i.labelId }))}
                  onChange={onCheck}
                  layout="vertical"
                />
              </div>
            </>
          ) : (
            <Empty style={{ paddingTop: 100 }} />
          )}
        </Spin>
      </div>
    </div>
  );
};

export default EnergyTree;
